import React from "react";
import "./Login_Header.css";
import { IoChevronBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";

function Login_Header({ title, subTitle }) {
  const navigate = useNavigate();

  return (
    <section className="login-header">
      <div
        className="back-icon"
        onClick={() => navigate(-1)} // 👈 Go to previous page
        style={{ cursor: "pointer" }}
      >
        <IoChevronBack />
      </div>

      <div className="brand_logo">
        <Link to="/home">
          <img
            src={"/assets/images/logo/money_king.png"}
            alt="logo"
            className="text_logo"
          />
        </Link>
      </div>

      <h2>{title}</h2>
      <p>{subTitle}</p>
    </section>
  );
}

export default Login_Header;